import { HTTP as http } from '../../http'

const PREFIX = '/contato'

export default {
    create: (data) => {
        return http.post(PREFIX+'/create', data)
    }
}